import { findParentNodeOfType } from 'prosemirror-utils';
import { blType, liType, olType } from './ListsSpecs';
export { liType, blType, olType } from './ListsSpecs';
export const findAnyParentList = (schema) => findParentNodeOfType([blType(schema), olType(schema)]);
export const isIntoListOfType = (nodeName) => (state) => { var _a; return ((_a = findAnyParentList(state.schema)(state.selection)) === null || _a === void 0 ? void 0 : _a.node.type.name) === nodeName; };
export const isListNode = ({ type }) => type === blType(type.schema) || type === olType(type.schema);
export const isListItemNode = (node) => node.type === liType(node.type.schema);
export const isListOrItemNode = (node) => isListNode(node) || isListItemNode(node);
